export default __webpack_public_path__ + "static/media/d34135d031a5d9f1.caa33f81a396efa0875623cb8c5b82cc.svg";